const {h, render, Component} = require('preact');

class OrderIdInput extends Component {
  constructor(props) {
      super(props);
  }

  render() {
    var invalid = !(this.props.isValid == true)
    return (
      <div>
        { !this.props.isValid && <div class="icon-circle-alert">{I18n.t('js.modules.web_2018.enter_valid_order_id')}</div>}
        <input value={this.props.orderId} oninput={(e) => this.props.handleInputChange('orderId', e)} data-bhw="guest_checkout_order_id_field" type="text" class="order-id-input" id="order-id-input" placeholder={I18n.t('js.modules.web_2018.order_id_placeholder')} invalid={invalid}></input>
      </div>
    )
  }
}

module.exports = OrderIdInput
